import RegistryHub from '@/pages/registry'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/registry/')({
  component: RegistryHub,
})
